// @flow

import * as types from '../ACTIONS/commonActionTypes';
import initialState from './commonInitialState';

export default function profileSetReducer(state = initialState.profileSet, ourClientId:number, action) {

    switch (action.type) {
        case types.GOT_CURRENT_PROFILESET: {
            const newState = {...state};
            newState.initialized = true;
            newState.curProfileSet = action.profileSet;
            return (newState);
        }
        default:
            return(state);
    }
}

